import React from 'react'
import { AlertCircle } from 'lucide-react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    // Atualiza o state para que a próxima renderização mostre a UI de fallback
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Log do erro para o console
    console.error('ErrorBoundary caught an error:', error, errorInfo)
    
    // Se for um erro GraphQL 500, não mostrar a tela de erro completa
    const isGraphQL500 = error?.message?.includes('500: Internal Server Error') ||
                         error?.graphQLErrors?.some(err => err.message?.includes('500'))
    
    if (isGraphQL500) {
      // Para erros GraphQL 500, apenas logar e não mostrar tela de erro
      console.error('GraphQL 500 error caught by ErrorBoundary:', error)
      this.setState({ hasError: false }) // Não mostrar erro para 500
      return
    }
    
    this.setState({
      error,
      errorInfo
    })
  }

  render() {
    if (this.state.hasError) {
      // UI de fallback customizada
      return (
        <div style={{
          padding: '2rem',
          textAlign: 'center',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'var(--bg-color, #f5f5f5)',
          color: 'var(--text-color, #333)'
        }}>
          <AlertCircle size={64} style={{ color: '#fd4f5d', marginBottom: '1rem' }} />
          <h1 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>
            Oops! Algo deu errado
          </h1>
          <p style={{ marginBottom: '2rem', opacity: 0.8 }}>
            Ocorreu um erro inesperado. Por favor, tente recarregar a página.
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null })
              window.location.reload()
            }}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600'
            }}
          >
            Recarregar Página
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{
              marginTop: '2rem',
              textAlign: 'left',
              maxWidth: '800px',
              backgroundColor: 'var(--card-bg, white)',
              padding: '1rem',
              borderRadius: '8px',
              border: '1px solid var(--card-border, #ddd)'
            }}>
              <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>
                Detalhes do erro (modo desenvolvimento)
              </summary>
              <pre style={{
                overflow: 'auto',
                fontSize: '0.875rem',
                color: '#d32f2f'
              }}>
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          )}
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
